<div class="homeContainer">
  <!-- <img src="assets/img/Intro_Portal_Imagen.jpg" alt=""> -->
  <app-change-password-card></app-change-password-card>
</div>